export default __webpack_public_path__ + "static/Group 1300-42b1c8bb7d3d2d61a88ed3bf3753c80e.png";